var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutilsEtUstensiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92949B"
    },
    points: "219.008,360.716 160.37,359.69 177.631,319.339 177.641,319.339 189.679,307.302  189.679,307.291 238.383,258.587 329.207,167.763 329.573,167.407 341.119,178.942 370.95,208.773 359.437,220.277 359.437,220.287  325.303,254.411 320.006,259.707 279.749,299.964 252.032,327.681 219.018,360.705 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8B33F"
    },
    d: "M38.03,498.994c-14.57-15.282-13.764-39.608,1.162-54.545l15.073-15.062l19.982-19.992l92.08-92.07 c2.564-2.564,6.73-2.564,9.295,0l2.01,2.01l15.062,15.062l26.315,26.315l2.01,2.01c2.575,2.575,2.575,6.73,0,9.295L93.381,499.664 C78.088,514.957,53.051,514.737,38.03,498.994z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66686D"
    },
    points: "177.631,319.339 177.641,319.339 189.679,307.302 189.679,307.291 238.383,258.587  329.207,167.763 329.573,167.407 341.119,178.942 329.605,190.445 329.605,190.456 295.471,224.579 290.175,229.875  249.918,270.132 222.2,297.85 189.187,330.874 189.176,330.884 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B54"
    },
    d: "M467.95,182.187c31.834,31.834,40.937,82.238,16.705,123.494 c-16.786-37.821-55.629-80.484-82.793-96.19l-1.321-44.021l48.039-2.652l0.015,0.015C459.32,173.556,467.114,181.35,467.95,182.187z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D39F37"
    },
    d: "M38.03,498.994c-14.57-15.282-13.764-39.608,1.162-54.545l15.073-15.062l19.982-19.992l92.08-92.07 c2.564-2.564,6.73-2.564,9.295,0l2.01,2.01h0.01l15.052,15.062C192.694,334.397,101.179,397.169,38.03,498.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B54"
    },
    d: "M391.175,75.864l-20.986,58.201l-55.582,18.367l0,0c5.649-7.983,6.685-18.464,2.343-27.226 c-1.616-3.259-3.843-6.395-6.657-9.21c-2.759-2.759-5.826-4.952-9.017-6.559c-8.787-4.426-19.35-3.386-27.414,2.252l0,0 l12.063-56.648l64.504-19.92l0,0c-5.907,8.548-6.683,19.775-1.588,28.829c1.521,2.703,3.47,5.294,5.837,7.66 c2.821,2.821,5.965,5.051,9.235,6.669C372.697,82.622,383.199,81.558,391.175,75.864L391.175,75.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92949B"
    },
    d: "M273.862,111.688l-35.12-35.12L315.31,0l35.12,35.12C350.43,35.12,275.312,110.282,273.862,111.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66686D"
    },
    d: "M287.938,97.611l-13.213,13.213c0,0-0.562,0.606-0.864,0.864l-35.12-35.12l14.991-14.991 l35.12,35.12C288.57,97.009,287.938,97.611,287.938,97.611z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66686D"
    },
    points: "359.437,220.277 318.07,178.91 318.06,178.91 329.207,167.763 329.573,167.407  370.95,208.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#66686D"
    },
    points: "279.749,299.964 238.383,258.587 258.807,238.162 300.184,279.529  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92949B"
    },
    d: "M463.369,148.059l-14.788,14.759l-31.945,31.9l-14.773,14.773l-15.099,15.099l-15.817-15.817 l0.007-0.007l-41.374-41.374l-0.007,0.007l-14.966-14.966c1.369-1.414,75.162-75.191,76.568-76.568 C391.175,75.864,436.472,121.161,463.369,148.059z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#484B54"
    },
    points: "311.101,307.508 332.79,329.197 289.364,372.623 267.675,350.934 276.81,341.799  301.966,316.644 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA3D3D"
    },
    d: "M472.165,472.148c0,10.195-3.894,20.401-11.671,28.178c-15.565,15.565-40.801,15.565-56.366,0 l-78.818-78.808c7.327-7.327,7.327-19.197,0-26.524c-7.327-7.327-19.197-7.327-26.514,0l-15.9-15.9l6.469-6.469l18.799-18.789 l24.629-24.64l6.469-6.469l15.9,15.9c-7.327,7.317-7.327,19.197,0,26.514c7.327,7.327,19.197,7.327,26.524,0l78.808,78.818 C468.271,451.737,472.165,461.943,472.165,472.148z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5B6BA"
    },
    points: "40.418,53.407 93.962,80.106 98.647,113.325 301.966,316.644 276.81,341.799 73.491,138.481  40.272,133.795 13.574,80.251 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D33333"
    },
    d: "M460.494,500.326c-15.565,15.565-40.801,15.565-56.366,0l-78.818-78.808 c7.327-7.327,7.327-19.197,0-26.524c-7.327-7.327-19.197-7.327-26.514,0l-15.9-15.9l6.469-6.469l18.799-18.789 C309.409,355.428,400.003,470.902,460.494,500.326z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutilsEtUstensiles);
export default __webpack_public_path__ + "static/media/outils-et-ustensiles.f1732039.svg";
export { ForwardRef as ReactComponent };